import moment from 'jalali-moment'

const Jalali = (date: any) => {
    if(date)
        return moment(date, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('YYYY/MM/DD HH:mm:ss')
}

export default Jalali;